import React, { useEffect } from "react";
import Navbar from "../components/site/Navbar";
import Hero from "../components/site/Hero";
import PartnerBar from "../components/site/PartnerBar";
import Services from "../components/site/Services";
import WhyUs from "../components/site/WhyUs";
import CaseStudies from "../components/site/CaseStudies";
import Testimonials from "../components/site/Testimonials";
import Consultation from "../components/site/Consultation";
import Contact from "../components/site/Contact";
import Footer from "../components/site/Footer";

export default function Home() {
  useEffect(() => {
    // Handle anchor after route landing
    if (window.location.hash) {
      const id = window.location.hash.replace("#", "");
      setTimeout(() => {
        const el = document.getElementById(id);
        if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
      }, 250);
    }

    // IntersectionObserver for reveal animations
    const els = document.querySelectorAll(".reveal");
    if ("IntersectionObserver" in window) {
      const io = new IntersectionObserver(
        (entries) => {
          entries.forEach((e) => {
            if (e.isIntersecting) {
              e.target.classList.add("visible");
              io.unobserve(e.target);
            }
          });
        },
        { threshold: 0.12 }
      );
      els.forEach((el) => io.observe(el));
      return () => io.disconnect();
    }
  }, []);

  return (
    <div className="min-h-screen">
      <Navbar />
      <main>
        <Hero />
        <PartnerBar />
        <Services />
        <WhyUs />
        <CaseStudies />
        <Testimonials />
        <Consultation />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}
